import React,{useEffect} from 'react';
export const Comp_Version_Details=(props)=>{
    let _versionName="";
    if(window.memc_system){
        if(typeof window.memc_system.getAppVersionCode==="function"){
          _versionName="("+window.memc_system.getAppVersionCode()+") ";
        }
        if(typeof window.memc_system.getAppVersionName==="function"){
          _versionName+=window.memc_system.getAppVersionName();
        }
       
        //alert("verions=== "+_versionName);
      }
useEffect(()=>{
    

},[props.versionInfo])
return(<div class="card">
    <div class="card-header">
      <h5 class="card-title">Version Details</h5>

      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fa fa-minus"></i>
        </button>
        <div class="btn-group">
          <button type="button" class="btn btn-tool dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-wrench"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" role="menu">
            <a href="#" class="dropdown-item">Action</a>
            <a href="#" class="dropdown-item">Another action</a>
            <a href="#" class="dropdown-item">Something else here</a>
            <a class="dropdown-divider"></a>
            <a href="#" class="dropdown-item">Separated link</a>
          </div>
        </div>
        <button type="button" class="btn btn-tool" data-card-widget="remove">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    
    <div class="card-body">
      <div class="row">
        <div class="col-md-8">
          <p class="text-center">
            <strong>----</strong>
          </p>
          <div class="d-flex">
          {/* info-box1 */}

          {props.versionInfo.data==="001"?
          <div class="info-box mr-2">
              <span class="info-box-icon bg-info"><i class="fa fa-cog"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Activated</span>
                <span class="info-box-number">Verions {_versionName}</span>
              </div>
              
            </div>:<div class="info-box mr-2">
              <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-cog"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">{props.versionInfo.data}</span>
                <span class="info-box-number">{props.versionInfo.msg}</span>
              </div>
              
              <div class="form-group">
<div class="input-group input-group-sm">
    <a href="javascript:void(0)" onClick={()=>window.location.reload()} class="btn btn-primary _btnSetColor11">Click here once license activated by admin</a>
    </div>

</div>
              
            </div>}

 
          
</div>

          
        </div>
        
        <div class="col-md-4">
          <p class="text-center">
            <strong>Version Details</strong>
          </p>

          <div class="progress-group">
            
           
          </div>
          

         

          

          
          
        </div>
        
      </div>
      
    </div>
    
    
  </div>)
}

export default Comp_Version_Details;